import React, { useEffect } from 'react';
import { useHistory } from "react-router-dom";
import QRCode from 'qrcode.react';

import { useQueryStrings } from '../../../hooks';
import useAppConfig from '../../../hooks/useAppConfig'
import Processing from '../../../components/processing';
import Button from 'react-bootstrap/Button';
import CopyButton from './CopyButton';

import styles from '../scss/QrCode.module.scss';

function QrCode(props) {
    const { token } = useQueryStrings(props.location.search);
    const { config, loading, error } = useAppConfig();
    const history = useHistory();

    useEffect(() => {
        if (error) {
            history.push("/error", { isDoctor: true });
        }
    }, [error, history]);

    if (loading) return <Processing />;
    if (error || !config) return null;

    const qrUrl = new URL(config);
    qrUrl.searchParams.set('launchToken', token);

    const qrVal = qrUrl.toString()

    function onContinue() {
        history.push({
            pathname: "/doctor/landing",
            search: `?token=${encodeURIComponent(token)}`
        });
    }

    return (
        <div className={styles.container}>
            <div className={styles.whiteBox}>
                <QRCode value={qrVal}
                    renderAs="svg"
                    bgColor="#ffffff"
                />
                <CopyButton text={qrVal} />
            </div>

            <Button variant="link" onClick={onContinue}>
                Continue in Socrates
            </Button>
        </div>
    )
}

export default QrCode